import { readVarM } from '@execonline-inc/environment';

export const localPublicUrl = (relativePublicPath: string): string =>
  readVarM('VITE_PUBLIC_URL')
    .map((publicUrl) => `${publicUrl}/${relativePublicPath}`)
    .getOrElseValue(`/p3/${relativePublicPath}`);
